module.exports = __webpack_public_path__ + "img/RITTAL.d0964b1e.png";